import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpParams, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { getDataForOauth, prepareDataForAuth } from "../utils";
import { IRESTConfig, OAuth2Service, RESTConfig } from "./angular-rest";
import { Inject } from "@angular/core";

export class SctAgendaInterceptor implements HttpInterceptor {

  constructor(@Inject(RESTConfig) private config: IRESTConfig) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    debugger

    if (!req.url.includes('auth') &&
      !req.url.includes('oauth') &&
      !req.url.includes('logout') &&
      !req.url.includes('login')) {
      // se non ho i dati per l'auth vado al logout
      if (!getDataForOauth()) {
        console.log(`Url ${req.url} senza auth`)
        localStorage.removeItem('auth-cookie-shortcut');
        document.location.href = `${this.config.baseURL}/${this.config.oauthNode}?redirect=${encodeURI(document.location.origin + '/login')}`;
        return;
      }
    }
    const __data = prepareDataForAuth()
    let addParam = false, addHeader = false

    // aggiungo l'auth per ogni richiesta 

    /*     if(req.url.indexOf('oauth') === -1 && !req.headers.get('Authorization') && !req.headers.get('authorization')) {
          addHeader = true
        } */

    if (req.url.indexOf('oauth') === -1 && !req.params.get('__data')
      && req.url.indexOf('__data') === -1) {
      addParam = true
    }

    const newReq = req.clone({
      withCredentials: true,
      // headers: addHeader ? req.headers.set('Authorization', `Bearer ${__data}`) : req.headers,
      params: addParam ? req.params.set('__data', __data) : req.params
    })

    console.log(`INTERCEPTOR\nURL ${newReq.url}\n>>HEADERS `, newReq.headers, "\n>>PARAMS ", newReq.params)

    return next.handle(newReq)
  }

}



// WEBPACK FOOTER //
// ./src/app/sct-agenda.interceptor.ts